import { Grid } from '@material-ui/core'
import React from 'react'
import { DoseItem } from '../../components'
import { IDose } from 'daily-dose-common'
import * as Utilities from '../../utilities'

interface IDoseListProps {
  doses: IDose[]
  orderBy?: keyof IDose
  mode?: 'asc' | 'desc'
}

const DoseList = ({
  doses,
  orderBy = 'createdAt',
  mode = 'asc',
}: IDoseListProps) => {
  const orderedDoses = Utilities.orderBy(doses, orderBy, mode)

  const renderDoseList = () =>
    orderedDoses.map((dose) => <DoseItem key={dose.id} dose={dose} link />)

  return (
    <Grid container spacing={2}>
      {renderDoseList()}
    </Grid>
  )
}

export default DoseList
